import React from 'react';
import { Lock, ChevronRight, Calendar, Crown } from 'lucide-react';
import { Snapshot } from '../types';
import { formatCurrency, formatCurrencyExact } from '../utils/formatters';
import { historicalLeaderboards } from '../data/mockData';
interface SnapshotHistoryProps {
  snapshots: Snapshot[];
  onViewAll: () => void;
  onOpenSnapshot: (snap: Snapshot) => void;
}
function getSnapshotStats(snapId: string) {
  const leaderboard = historicalLeaderboards[snapId] || [];
  if (leaderboard.length === 0) {
    return {
      winner: null,
      periodAvgRevenue: 0
    };
  }
  // Top by avg revenue
  const sorted = [...leaderboard].sort((a, b) => b.avgRevenue - a.avgRevenue);
  const winner = sorted[0];
  const periodAvgRevenue = leaderboard.reduce((sum, a) => sum + a.avgRevenue, 0) / leaderboard.length;
  return {
    winner,
    periodAvgRevenue
  };
}
export function SnapshotHistory({
  snapshots,
  onViewAll,
  onOpenSnapshot
}: SnapshotHistoryProps) {
  return <section id="snapshot-history" className="mb-12 scroll-mt-8" data-id="element-562">
      <div className="flex items-center justify-between mb-6" data-id="element-563">
        <div data-id="element-564">
          <h2 className="text-xl font-semibold text-white flex items-center gap-2" data-id="element-565">
            <Calendar className="w-5 h-5 text-indigo-400" data-id="element-566" />
            Historical Snapshots
          </h2>
          <p className="text-sm text-slate-400 mt-1" data-id="element-567">
            Preserved month-end performance records
          </p>
        </div>
        <button onClick={onViewAll} className="text-sm text-indigo-400 hover:text-indigo-300 font-medium flex items-center gap-1 transition-colors" data-id="element-568">
          View All <ChevronRight className="w-4 h-4" data-id="element-569" />
        </button>
      </div>

      <div className="flex gap-4 overflow-x-auto pb-4 snap-x" data-id="element-570">
        {snapshots.map(snap => {
        const {
          winner,
          periodAvgRevenue
        } = getSnapshotStats(snap.id);
        return <button key={snap.id} onClick={() => onOpenSnapshot(snap)} className="snap-start shrink-0 w-72 glass-panel rounded-2xl p-5 relative cursor-pointer text-left hover:border-white/20 transition-colors" data-id="element-571">
              <div className="absolute top-4 right-4 text-slate-500" data-id="element-572">
                <Lock className="w-4 h-4" data-id="element-573" />
              </div>

              <div className="mb-4" data-id="element-574">
                <h3 className="text-lg font-bold text-white" data-id="element-575">
                  {snap.month} {snap.year}
                </h3>
                <p className="text-xs text-slate-500 mt-0.5" data-id="element-576">
                  Finalized on {new Date(snap.lockedAt!).toLocaleDateString()}
                </p>
              </div>

              <div className="space-y-3" data-id="element-577">
                {winner && <div className="bg-black/20 rounded-xl p-3 border border-white/5" data-id="element-578">
                    <p className="text-xs text-slate-400 mb-1 flex items-center gap-1.5" data-id="element-579">
                      <Crown className="w-3 h-3 text-yellow-400" data-id="element-580" /> Top
                      Performer
                    </p>
                    <p className="text-sm font-semibold text-white truncate" data-id="element-581">
                      {winner.name}
                    </p>
                    <p className="text-xs text-emerald-400 font-medium mt-0.5" data-id="element-582">
                      {formatCurrencyExact(winner.avgRevenue)} avg rev
                    </p>
                  </div>}
                <div className="bg-black/20 rounded-xl p-3 border border-white/5" data-id="element-583">
                  <p className="text-xs text-slate-400 mb-1" data-id="element-584">
                    Period Avg Revenue
                  </p>
                  <p className="text-sm font-semibold text-emerald-400" data-id="element-585">
                    {formatCurrencyExact(periodAvgRevenue)}
                  </p>
                </div>
              </div>

              <div className="mt-4 pt-4 border-t border-white/10 flex items-center justify-between" data-id="element-586">
                <span className="text-xs text-slate-400" data-id="element-587">View Leaderboard</span>
                <ChevronRight className="w-4 h-4 text-slate-500" data-id="element-588" />
              </div>
            </button>;
      })}
      </div>
    </section>;
}